var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "option-migration",
      attrs: {
        id: "option-migration",
        title: "Migrar identificador del Grupo de opciones",
        "hide-footer": "",
        "no-close-on-backdrop": "",
        size: "xl"
      }
    },
    [
      _vm.option
        ? _c("div", { staticClass: "row mb-5" }, [
            _vm.isList
              ? _c("div", { staticClass: "col-md-8 col-12 mt-3" }, [
                  _c("label", [
                    _vm._v("Migrar " + _vm._s(this.option.length) + " opciones")
                  ])
                ])
              : _vm._e(),
            !_vm.isList
              ? _c("div", { staticClass: "col-md-8 col-12 mt-3" }, [
                  _c("label", [_vm._v("Nombre de la opción")]),
                  _vm._v(" " + _vm._s(_vm.option.descripcion) + " ")
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "col-md-12 mt-3" },
              [
                _c("label", [_vm._v("Ambiente destino")]),
                _c("v-select", {
                  attrs: {
                    multiple: "",
                    label: "title",
                    options: _vm.availableEnvironments
                  },
                  model: {
                    value: _vm.environmentsToMigrate,
                    callback: function($$v) {
                      _vm.environmentsToMigrate = $$v
                    },
                    expression: "environmentsToMigrate"
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "col-md-12 mt-3" }, [
              _c(
                "div",
                { staticStyle: { float: "right" } },
                [
                  !_vm.isSavingOption
                    ? _c(
                        "vs-button",
                        {
                          staticClass: "action",
                          attrs: {
                            color: "primary",
                            type: "border",
                            icon: "save"
                          },
                          on: {
                            click: function($event) {
                              return _vm.sendMigrationOption()
                            }
                          }
                        },
                        [_vm._v(" Guardar ")]
                      )
                    : _c("b-spinner", {
                        key: "primary",
                        staticClass: "mr-1",
                        attrs: { variant: "primary" }
                      })
                ],
                1
              )
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }